
// actions.js
export const CREATE_LEAD_REQUEST = 'CREATE_LEAD_REQUEST';
export const CREATE_LEAD_SUCCESS = 'CREATE_LEAD_SUCCESS';
export const CREATE_LEAD_FAILURE = 'CREATE_LEAD_FAILURE';


// delete action type
export const DELETE_LEAD_REQUEST = 'DELETE_LEAD_REQUEST';
export const DELETE_LEAD_SUCCESS = 'DELETE_LEAD_SUCCESS';
export const DELETE_LEAD_FAILURE = 'DELETE_LEAD_FAILURE';


// edit action type
export const EDIT_LEAD_REQUEST = 'EDIT_LEAD_REQUEST';
export const EDIT_LEAD_SUCCESS = 'EDIT_LEAD_SUCCESS';
export const EDIT_LEAD_FAILURE = 'EDIT_LEAD_FAILURE';


// edit action type
export const EDIT_LEAD_ALL_REQUEST = 'EDIT_LEAD_ALL_REQUEST';
export const EDIT_LEAD_ALL_SUCCESS = 'EDIT_LEAD_ALL_SUCCESS';
export const EDIT_LEAD_ALL_FAILURE = 'EDIT_LEAD_ALL_FAILURE';


export const RESET_SUCCESS_STATE = 'RESET_SUCCESS_STATE'